import { useLocation } from 'react-router-dom';
import { apis, id } from '../constants';
import { _getVanillan, _post, get, post } from './fetchHelper';

export const useBackendApi = () => {
  const location = useLocation();
  // paths are not being resolved by useParams where context is not inside route components
  const communityName = location.pathname.split('/')?.[1];

  const cacheRequest = async (storageId, api, expireMillis = 6 * 60 * 60 * 1000, resetCache) => {
    let cache = JSON.parse(localStorage.getItem(storageId));
    const currentTime = Date.now();
    if (!cache?.data || cache?.expireAt < currentTime || resetCache) {
      cache = { data: await api() };
      cache.expireAt = currentTime + expireMillis;
      localStorage.setItem(storageId, JSON.stringify(cache));
    }
    return cache.data;
  };

  return {
    login: async body => post(apis.backend.login(), body),
    logout: async () => _post(apis.backend.logout()),
    refreshAccessToken: async () => post(apis.backend.refreshAccessToken()),
    getAccessTokenForWallet: async body => _post(apis.backend.login(), body),
    getCookies: async body => post(apis.backend.loginGetCookies(), body),
    getLoginState: async body => post(apis.backend.getLoginState(), body),

    getAllBanners: async () => cacheRequest('banner', () => get(apis.backend.get_allBanners())),
    getAnalyticsData: async body => post(apis.backend.getAnalyticsData(), body),
    saveWhitelist: async body => post(apis.backend.saveWhitelist(), body),
    user: {
      getIdentityClaims: async () => get(apis.backend.getUserIdentityClaims()),
      disconnectAccount: async body => post(apis.backend.disconnectAccount(), body),
      getUserActivity: async () => get(apis.backend.getUserActivity()),
      setUserName: async body => post(apis.backend.setUserName(), body),
      checkUserName: async username => get(apis.backend.checkUserName(username)),
    },

    mrep: {
      getAllScores: address => get(apis.backend.getAllMrepData(address)),
      getSwapScores: address => get(apis.backend.getMrepSwapStats(address)),
      getBridgeScores: address => get(apis.backend.getMrepBridgeStats(address)),
      getAllProtocols: () => get(apis.backend.getAllProtocols()),
    },
    communities: {
      get: async (communityName, resetCache) => cacheRequest(id.storage.community(communityName), () => get(apis.backend.getCommunity(communityName)), null, resetCache),
    },
  };
};

export const useGelatoApi = () => {
  return {
    getTxn: taskId => _getVanillan(apis.gelato.getTxn(taskId)),
  };
};
